import { z } from 'zod';

export const PasswordSchema = z
  .object({
    password: z.string(),
    newPasswordConfirm: z.string(),
    newPassword: z.string().regex(/^(?=.*[A-Za-z])(?=.*\d).{8,20}$/, '8–20 characters, at least 1 number and 1 letter'),
  })
  .refine(data => data.newPassword === data.newPasswordConfirm, {
    message: "Passwords don't match. Please try again",
    path: ['newPasswordConfirm'], // 错误信息会显示在 newPasswordConfirm 字段上
  });

export type PasswordDetail = z.infer<typeof PasswordSchema>;
